import request from "../../../utils/wapRequest";
let domainApi = process.env.VUE_APP_WAP_API;
const URL_API_BOOKING_VCALL = process.env.VUE_APP_BASE_API_BOOKING_VCALL;
const BASE_URL_STAGING = process.env.VUE_APP_BASE_API_STAGING;
const URL_API_GROUP = process.env.VUE_APP_BASE_API_GROUP;
const BASE_URL_LOGIN = process.env.VUE_APP_BASE_LOGIN;

const HomepageResource = {
  listPriceBooking(params) {
    return request({
      url: URL_API_GROUP + `/api/v1/other/list_price_booking`,
      method: "GET",
      headers: {
        token: "A4KcOxIPiLr9oPqDNX0AWJlN1SIhBIt7cfHE6SHDYWPj5dTWUIQCxD961e"
      },
      params
    });
  },
  listTeetime(params) {
    return request({
      url: URL_API_BOOKING_VCALL + `/booking_pax/sugestion_teetime_for_wap`,
      method: "GET",
      headers: {
        token: "A4KcOxIPiLr9oPqDNX0AWJlN1SIhBIt7cfHE6SHDYWPj5dTWUIQCxD961e"
      },
      params
    });
  },

  getImageFacility(data) {
    return request({
      url: `${BASE_URL_LOGIN}/services/get_images_courses`,
      method: "POST",
      data
    });
  },
  bookingNowForWap(data) {
    return request({
      url: `${URL_API_BOOKING_VCALL}/booking_pax/booking_now_for_wap`,
      headers: {
        token: "A4KcOxIPiLr9oPqDNX0AWJlN1SIhBIt7cfHE6SHDYWPj5dTWUIQCxD961e"
      },
      method: "POST",
      data
    });
  },
  verifyBookingNowForWap(data) {
    return request({
      url: `${URL_API_BOOKING_VCALL}/booking_pax/verify_booking_now_for_wap`,
      headers: {
        token: "A4KcOxIPiLr9oPqDNX0AWJlN1SIhBIt7cfHE6SHDYWPj5dTWUIQCxD961e"
      },
      method: "POST",
      data
    });
  },
  getBannerHomePage(params) {
    return request({
      url: BASE_URL_STAGING + `/adv/home_ads`,
      method: "GET",
      params
    });
  },
  getPriceFacility(params) {
    return request({
      url: `${domainApi}/list_price_booking_for_wap`,
      method: "GET",
      params
    });
  }
};
export { HomepageResource as default };
